import { motion } from "framer-motion";
import { CHAPTERS, STATS, IMAGES } from "@/data/site";
import { Reveal, SplitLines, Counter, EASE } from "@/components/motion/Reveal";

export const Manifesto = () => (
  <section id="about" data-testid="manifesto-section" className="relative py-24 sm:py-32 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal y={16} className="eyebrow mb-4">The Big Rickie's way</Reveal>
          <h2 className="h-display text-4xl sm:text-5xl lg:text-6xl text-white">
            <SplitLines lines={["Not a franchise.", "Not a gimmick.", <>Just a <span className="text-brand-light">bloke</span></>, "who does it right."]} />
          </h2>
          <Reveal delay={0.3} className="mt-10 relative">
            <div className="clip-frame-alt aspect-[5/4] overflow-hidden">
              <motion.img
                src={IMAGES.trailer}
                alt="Big Rickie's pressure washing trailer rig"
                className="w-full h-full object-cover"
                initial={{ scale: 1.2 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.6, ease: EASE }}
              />
            </div>
            <div className="absolute -bottom-4 -right-2 sm:-right-6 bg-panel border border-white/10 rounded-md px-4 py-3 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-300">
              Fig. 02 — The rig, ready to roll
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:pt-24">
          <ol className="space-y-0">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.1} className="group hairline py-8 sm:py-10 grid grid-cols-[auto_1fr] gap-6 sm:gap-10" data-testid={`chapter-${c.n}`}>
                <span className="font-display font-black text-5xl sm:text-6xl text-brand-light/80 leading-none tabular-nums group-hover:text-brand-light transition-colors duration-300">{c.n}</span>
                <div>
                  <h3 className="font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl text-white mb-3">{c.title}</h3>
                  <p className="text-slate-400 leading-relaxed text-sm sm:text-base max-w-lg">{c.body}</p>
                </div>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>

      <div className="mt-20 sm:mt-28 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-xl overflow-hidden" data-testid="stats-grid">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 0.8, delay: i * 0.08, ease: EASE }}
            className="bg-ink2 hover:bg-panel transition-colors duration-300 p-6 sm:p-8"
            data-testid={`stat-${i}`}
          >
            <div className="font-display font-black text-5xl sm:text-6xl text-white leading-none tracking-tight">
              <Counter value={s.value} suffix={s.suffix} prefix={s.prefix} decimals={s.decimals || 0} />
            </div>
            <div className="mt-3 font-display font-bold uppercase tracking-wider text-sm text-brand-light">{s.label}</div>
            <div className="text-xs text-slate-500 mt-1">{s.sub}</div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
